import React, { useRef } from "react";
import InmateInfo from "./InmateInfo";
import InmateMessage from "./InmateMessage";
import InmatePhotos from "./InmatePhotos";
import InmateEcard from "./InmateEcard";
import InmateFreeCredits from "./InmateFreeCredits";
import InmateDebitHistory from "./InmateDebitHistory";
import InmateConnectionRequest from "./InmateConnectionRequest";
import InmateReports from "./InmateReports";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { authActions, eCardAction, inmateAction } from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { UserRoleType, MenuItem } from "../../_helpers/enumerator";
import { history } from "../../_helpers/history.js";
import InmateTransaction from "./InmateTransaction.jsx";
import dragicon from "../../assets/svg/click-and-drag.svg";
import { useLocation } from "react-router-dom";
function InmateDetails() {
  // Getting user details
  const { user, userAccessibleMenuInfo } = useSelector((x) => x.auth);
  const { commonFacilityCode } = useSelector((state) => state.auth);
  const { inmateCurrentTab: activeTab } = useSelector((x) => x.inmate);
  const location = useLocation();
  let IsShowTransactionTab = location?.state?.showTransactionTab;
  // const [activeTab, setActiveTab] = useState("inmate-info-tab");
  const dispatch = useDispatch();

  // Hide or show reports tab
  const shouldShowReportsTab = [
    UserRoleType.SuperAdmin,
    UserRoleType.FacilitySuperAdmin,
    UserRoleType.InvestigatorsStaff,
    UserRoleType.FacilityStaffSAO,
  ].includes(user.UserRoleID);

  // Get Role ID
  const isEligibleRole = [
    UserRoleType.FacilityStaffSAO,
    UserRoleType.FacilitySuperAdmin,
    UserRoleType.FacilityAdmin,
    UserRoleType.InvestigatorsStaff,
    UserRoleType.SuperAdmin,
  ].includes(user.UserRoleID);

  // Requests Info
  const isRequestsInfo = [UserRoleType.FacilityStaffSAO].includes(
    user.UserRoleID
  );

  // Initiate Info
  const isInitiate = [
    UserRoleType.InvestigatorsStaff,
    UserRoleType.FacilityStaffSAO,
  ].includes(user.UserRoleID);

  // PostalMail Info
  const isPostalMail = [UserRoleType.FacilityStaffSAO].includes(
    user.UserRoleID
  );

  // Hide or show Connection Requests tab
  const shouldHideConnectionRequestsTab =
    user.UserRoleID === UserRoleType.InvestigatorsStaff;
  // Hide or show Debits Info tab
  const shouldHideDebitsInfoTab =
    user.UserRoleID === UserRoleType.InvestigatorsStaff;
  // Hide or show Free Credits tab
  const shouldHideFreeCreditsInfoTab =
    user.UserRoleID === UserRoleType.InvestigatorsStaff;

  // Hide or Show Message Tab
  const shouldShowMessageTab =
    Array.isArray(userAccessibleMenuInfo) && userAccessibleMenuInfo.length > 0
      ? userAccessibleMenuInfo.some(
        (item) =>
          item?.ManagementMenuID === MenuItem.MessagesMenuItem &&
          item?.MenuActiveStatus === 1
      )
      : true;
  // Hide or Show Photo Tab
  const shouldShowPhotoTab =
    Array.isArray(userAccessibleMenuInfo) && userAccessibleMenuInfo.length > 0
      ? userAccessibleMenuInfo.some(
        (item) =>
          item?.ManagementMenuID === MenuItem.PhotosMenuItem &&
          item?.MenuActiveStatus === 1
      )
      : true;

  const shouldShowEcardTab =
    Array.isArray(userAccessibleMenuInfo) && userAccessibleMenuInfo.length > 0
      ? userAccessibleMenuInfo.some(
        (item) =>
          item?.ManagementMenuID === MenuItem.EcardMenuItem &&
          item?.MenuActiveStatus === 1
      )
      : true;

  // Load facility dropdown on component mount
  const prevFacilityCodeRef = useRef(commonFacilityCode);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== commonFacilityCode) {
      history.navigate("InmateList");
    }
  }, [commonFacilityCode]);

  // Get User Accessible Menu Info
  useEffect(() => {
    dispatch(authActions.GetUserAccessibleMenuInfo(user.ManagementUserID));
  }, [dispatch]);

  const handleTabClick = (tabId) => {
    // setActiveTab(tabId);

    dispatch(inmateAction.setInmateCurrentTab(tabId));

    if (tabId === "inmate-message-tab" || tabId === "inmate-photos-tab") {
      dispatch(
        authActions.GetUserAccessibleMenuInfo(user.ManagementUserID)
      ).then((res) => {
        // Hide or Show Message Tab btn
        const shouldShowMessage =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.ManagementMenuID === 10 && item?.MenuActiveStatus === 1
            )
            : true; // Menu ID 10

        // Hide or Show Photo Tab
        const shouldShowPhoto =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.ManagementMenuID === 11 && item?.MenuActiveStatus === 1
            )
            : true; // Menu ID 11
        if (!shouldShowMessage && !shouldShowPhoto) {
          dispatch(inmateAction.setInmateCurrentTab(tabId));
          showToastNotification(
            "The Message and Photo menus have been disabled by the admin.",
            "error"
          );
        } else if (!shouldShowMessage && tabId === "inmate-message-tab") {
          dispatch(inmateAction.setInmateCurrentTab(tabId));
          showToastNotification(
            "The Message menu has been disabled by the admin.",
            "error"
          );
        } else if (!shouldShowPhoto && tabId === "inmate-photos-tab") {
          dispatch(inmateAction.setInmateCurrentTab(tabId));
          showToastNotification(
            "The Photo menu has been disabled by the admin.",
            "error"
          );
        } else {
          dispatch(inmateAction.setInmateCurrentTab(tabId));
        }
      });
    } else {
      dispatch(inmateAction.setInmateCurrentTab(tabId));
    }
  };

  // Handle Tab Click
  // const handleTabClick = (tabId) => {
  //   setActiveTab(tabId);
  // };

  return (
    <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
      <div className="overflow-auto">
        <ul
          className="nav nav-tabs tab-bg d-flex flex-nowrap overflow-auto"
          style={{ whiteSpace: "nowrap" }}
        >
          <li className="nav-item flex-shrink-0">
            <a
              href="#inmate-info-tab"
              data-bs-toggle="tab"
              className={`nav-link ${activeTab === "inmate-info-tab" ? "active" : "text-black"
                }`}
              onClick={() => handleTabClick("inmate-info-tab")}
            >
              <span className=" font-size-15 ">
                <i className="fa fa-info-circle"></i> Info
              </span>
            </a>
          </li>
          {isEligibleRole && shouldShowMessageTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#inmate-message-tab"
                data-bs-toggle="tab"
                className={`nav-link ${activeTab === "inmate-message-tab" ? "active" : "text-black"
                  }`}
                onClick={() => {
                  handleTabClick("inmate-message-tab");
                  dispatch(inmateAction.clearInitiateMessageSearch())
                }}
              >
                <span className=" font-size-15 ">
                  <i className="fa fa-comment"></i> Messages
                </span>
              </a>
            </li>
          )}
          {isEligibleRole && shouldShowPhotoTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#inmate-photos-tab"
                data-bs-toggle="tab"
                className={`nav-link ${activeTab === "inmate-photos-tab" ? "active" : "text-black"
                  }`}
                onClick={() => {
                  handleTabClick("inmate-photos-tab");
                  dispatch(inmateAction.clearInitialPhotosSearch())
                }}
              >
                <span className="font-size-15 ">
                  <i className="fa fa-camera"></i> Photos
                </span>
              </a>
            </li>
          )}
          {isEligibleRole && shouldShowEcardTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#inmate-ecard-tab"
                data-bs-toggle="tab"
                className={`nav-link ${activeTab === "inmate-ecard-tab" ? "active" : "text-black"
                  }`}
                onClick={() => {
                  handleTabClick("inmate-ecard-tab");
                  dispatch(eCardAction.resetSentEcardSearch())
                }}
              >
                <span className="font-size-15 ">
                  <i className="fa fa-envelope"></i> E-Cards
                </span>
              </a>
            </li>
          )}
          {IsShowTransactionTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#inmate-transaction-tab"
                data-bs-toggle="tab"
                className={`nav-link ${activeTab === "inmate-transaction-tab"
                  ? "active"
                  : "text-black"
                  }`}
                onClick={() => handleTabClick("inmate-transaction-tab")}
              >
                <span className=" font-size-15 ">
                  <i className="fa-solid fa-receipt"></i> Transactions
                </span>
              </a>
            </li>
          )}

          {!shouldHideFreeCreditsInfoTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#inmate-free-credits"
                data-bs-toggle="tab"
                className={`nav-link ${activeTab === "inmate-free-credits" ? "active" : "text-black"
                  }`}
                onClick={() => handleTabClick("inmate-free-credits")}
              >
                <span className=" font-size-15 ">
                  <i className="fa fa-usd" aria-hidden="true"></i> Free Credits
                </span>
              </a>
            </li>
          )}
          {!shouldHideDebitsInfoTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#inmate-debit-history-tab"
                data-bs-toggle="tab"
                className={`nav-link ${activeTab === "inmate-debit-history-tab"
                  ? "active"
                  : "text-black"
                  }`}
                onClick={() => handleTabClick("inmate-debit-history-tab")}
              >
                <span className=" font-size-15 ">
                  <i className="fa fa-history"></i> Debit History
                </span>
              </a>
            </li>
          )}
          {!shouldHideConnectionRequestsTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#inmate-connection-request"
                data-bs-toggle="tab"
                className={`nav-link ${activeTab === "inmate-connection-request"
                  ? "active"
                  : "text-black"
                  }`}
                onClick={() => handleTabClick("inmate-connection-request")}
              >
                <span className=" font-size-15 ">
                  <i className="fa fa-plug"></i> Connection Requests
                </span>
              </a>
            </li>
          )}
          {shouldShowReportsTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#inmate-reports-tab"
                data-bs-toggle="tab"
                className={`nav-link ${activeTab === "inmate-reports-tab" ? "active" : "text-black"
                  }`}
                onClick={() => handleTabClick("inmate-reports-tab")}
              >
                <span className=" font-size-15 ">
                  <i className="fa fa-reorder"></i> Reports
                </span>
              </a>
            </li>
          )}
        </ul>
        <div className="dragicon-container">
          <img
            src={dragicon}
            alt="pending-status"
            title="Pending"
            className="dragicon"
          />
        </div>
        <div className="tab-content panel rounded-0 mt-3 m-0">
          <div
            className={`tab-pane fade ${activeTab === "inmate-info-tab" ? "active show" : "text-black"
              }`}
            id="inmate-info-tab"
          >
            {activeTab === "inmate-info-tab" && <InmateInfo />}
          </div>
          {isEligibleRole && shouldShowMessageTab && (
            <div
              className={`tab-pane fade ${activeTab === "inmate-message-tab"
                ? "active show"
                : "text-black"
                }`}
              id="inmate-message-tab"
            >
              {activeTab === "inmate-message-tab" && <InmateMessage />}
            </div>
          )}
          {isEligibleRole && shouldShowPhotoTab && (
            <div
              className={`tab-pane fade ${activeTab === "inmate-photos-tab" ? "active show" : "text-black"
                }`}
              id="inmate-photos-tab"
            >
              {activeTab === "inmate-photos-tab" && <InmatePhotos />}
            </div>
          )}
          {isEligibleRole && shouldShowEcardTab && (
            <div
              className={`tab-pane fade ${activeTab === "inmate-ecard-tab" ? "active show" : "text-black"
                }`}
              id="inmate-ecard-tab"
            >
              {activeTab === "inmate-ecard-tab" && <InmateEcard />}
            </div>
          )}
          <div
            className={`tab-pane fade ${activeTab === "inmate-transaction-tab"
              ? "active show"
              : "text-black"
              }`}
            id="inmate-transaction-tab"
          >
            {activeTab === "inmate-transaction-tab" && <InmateTransaction />}
          </div>
          {!shouldHideFreeCreditsInfoTab && (
            <div
              className={`tab-pane fade ${activeTab === "inmate-free-credits"
                ? "active show"
                : "text-black"
                }`}
              id="inmate-free-credits"
            >
              {activeTab === "inmate-free-credits" && <InmateFreeCredits />}
            </div>
          )}
          {!shouldHideDebitsInfoTab && (
            <div
              className={`tab-pane fade ${activeTab === "inmate-debit-history-tab"
                ? "active show"
                : "text-black"
                }`}
              id="inmate-debit-history-tab"
            >
              {activeTab === "inmate-debit-history-tab" && (
                <InmateDebitHistory />
              )}
            </div>
          )}
          {!shouldHideConnectionRequestsTab && (
            <div
              className={`tab-pane fade ${activeTab === "inmate-connection-request"
                ? "active show"
                : "text-black"
                }`}
              id="inmate-connection-request"
            >
              {activeTab === "inmate-connection-request" && (
                <InmateConnectionRequest />
              )}
            </div>
          )}
          {shouldShowReportsTab && (
            <div
              className={`tab-pane fade ${activeTab === "inmate-reports-tab"
                ? "active show"
                : "text-black"
                }`}
              id="inmate-reports-tab"
            >
              {activeTab === "inmate-reports-tab" && (
                <InmateReports
                  isPostalMail={isPostalMail}
                  isInitiate={isInitiate}
                  isRequestsInfo={isRequestsInfo}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div >
  );
}

export default React.memo(InmateDetails);
